import React from 'react';

const Footer: React.FC = () => {
  const handleNavClick = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-ink-900 text-surface py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col sm:flex-row gap-6 items-center">
            <p className="text-ink-300">
              &copy; 2025 3B Consulting. All rights reserved.
            </p>
            <nav className="flex gap-6">
              <button
                onClick={() => handleNavClick('#services')}
                className="text-ink-300 hover:text-brand-start transition-colors duration-200"
              >
                Services
              </button>
              <button
                onClick={() => handleNavClick('#about')}
                className="text-ink-300 hover:text-brand-start transition-colors duration-200"
              >
                About
              </button>
              <button
                onClick={() => handleNavClick('#contact')}
                className="text-ink-300 hover:text-brand-start transition-colors duration-200"
              >
                Contact
              </button>
            </nav>
          </div>
          <div className="text-center md:text-right">
            <p className="text-ink-500 text-sm">
              
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 